module.exports = __webpack_public_path__ + "static/media/exit-hover.40f49200.svg";